import type { PropsWithChildren } from "react";
import { useSession } from "../auth/sessionContext";
import { InlineNotice } from "../components/Feedback/InlineNotice";
import { hasRevenueAccess } from "./revenueAccess";
import "./RevenuePage.css";

export function RevenueRouteGuard({ children }: PropsWithChildren) {
  const session = useSession();
  if (!hasRevenueAccess(session)) {
    return (
      <section className="rv-denied" data-status-code="403" aria-label="Revenue unavailable">
        <InlineNotice tone="error" title="403 — Revenue unavailable">
          {session.user.role !== "owner"
            ? "Revenue contains owner-only financial information."
            : "Revenue is not enabled for this workspace."}
        </InlineNotice>
      </section>
    );
  }
  return children;
}
